// Handle legacy hash URLs by redirecting to proper BrowserRouter format
(function legacyUrlRedirect() {
  const { hash, pathname, protocol, host, search } = window.location;

  // Handle /index.html paths (with or without hash)
  if (pathname.match(/\/index\.html$/i)) {
    // For root /index.html (production case), redirect to home
    if (pathname === '/index.html') {
      if (hash && hash.startsWith('#/')) {
        // /index.html#/accounts -> /accounts
        const path = hash.substring(1);
        const newUrl = `${protocol}//${host}${path}${search}`;
        window.location.replace(newUrl);
        return;
      }
      // /index.html -> /
      const newUrl = `${protocol}//${host}/${search}`;
      window.location.replace(newUrl);
      return;
    }

    // For nested index.html paths (branch builds), set up redirect to accounts if no hash
    // and no existing spa-restore-path (which would indicate a specific route was intended)
    if (!hash && !sessionStorage.getItem('spa-restore-path')) {
      // Store the intended route path for the React app to restore (redirect to accounts)
      sessionStorage.setItem('spa-restore-path', `/accounts${search}`);
    }
    return; // Let React Router handle it
  }

  if (hash && hash.startsWith('#/')) {
    // For root path, process hash URL directly (production case)
    if (pathname === '/') {
      const path = hash.substring(1);
      const newUrl = `${protocol}//${host}${path}${search}`;
      window.location.replace(newUrl);
      return;
    }

    // For subdirectory paths with hash (e.g., /branch/#/accounts),
    // redirect to index.html with the same hash
    if (pathname.endsWith('/')) {
      const newUrl = `${protocol}//${host}${pathname}index.html${hash}${search}`;
      window.location.replace(newUrl);
      return;
    }

    // For other legacy hash URLs, redirect to the proper React Router path
    const path = hash.substring(1);
    const basePath = pathname.replace(/\/$/, '');
    const newUrl = `${protocol}//${host}${basePath}${path}${search}`;
    window.location.replace(newUrl);
  }
})();

// oxlint-disable-next-line unicorn/require-module-specifiers
export {};
